import { CurrencyPipe, DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { MakeAPaymentService } from '../../../custom-make-a-payment/make-a-payment.service';
import { LoactionStripService } from '../../../shared/modules/location-strip/loaction-strip.service';
import { CommonUtils } from '../../../shared/utils/common.utils';
import {
  NumberTen,
  NumberThree,
  NumberTwo,
} from '../../../shared/utils/constants/global.constants';
import { InvoiceUtils } from '../../../shared/utils/invoice.utils';
import { AccountOverviewService } from '../../account-overview.service';
const symbolNarrow = 'symbol-narrow';
const tabs = ['INVOICES', 'CREDITS', 'STATEMENTS'];
@Component({
  selector: 'app-financials-list',
  templateUrl: './financials-list.component.html',
  styleUrls: ['./financials-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FinancialsListComponent implements OnInit, OnDestroy {
  isLoadingDone = false;
  selectedTab: string = tabs[0];
  removeAside = true;
  currentDate = new Date();
  paymentList: any = [];
  showdropdown = false;
  creditList: any = [];
  payment: any;
  myDate: string;
  userAccSub: Subscription;
  creditItems: any = [];
  invoiceItems: any = [];
  creditDropDownSource: any[];
  listofSelectedInvoices: any = [];
  indexOfSelectedInvoice: any;
  accountNumber: string = null;
  isPDF = false;
  showXlsPdf = false;
  excelInvoiceHeaderIds: string[] = [
    'docDate',
    'docNo',
    'dueDate',
    //'amount',
    'amountDue',
  ];
  excelCreditsHeaderIds: string[] = ['creditDate', 'creditNo', 'creditAmt'];
  creditInvoiceSub: Subscription;
  constructor(
    private readonly datePipe: DatePipe,
    private readonly currencyPipe: CurrencyPipe,
    private readonly makeAPayment: MakeAPaymentService,
    private readonly cdr: ChangeDetectorRef,
    private readonly acService: AccountOverviewService,
    protected locationStripService: LoactionStripService
  ) {}

  ngOnInit(): void {
    this.invoiceItems = [];
    this.creditItems = [];
    sessionStorage.removeItem('creditData');
    sessionStorage.removeItem('invoicesData');
    this.myDate = this.datePipe.transform(this.currentDate, 'dd/MM/yyyy');
    this.userAccSub = this.locationStripService.userAccountData.subscribe(
      (res) => {
        if (_.isEmpty(this.accountNumber)) {
          this.accountNumber = res?.uid;
          this.getInvoicesCreditData();
          this.cdr.detectChanges();
          this.userAccSub?.unsubscribe();
        }
      }
    );
    this.creditInvoiceSub = this.makeAPayment.creditInvoiceDate$.subscribe(
      (res) => {
        if (res !== false) {
          this.paymentList = InvoiceUtils.getInvoiceTableData(res.openInvoices);
          this.creditDropDownSource = InvoiceUtils.getCreditDropDownSource(
            this.paymentList
          );
          this.creditList = InvoiceUtils.getCreditTableData(
            res.openInvoices,
            this.creditDropDownSource
          );

          this.paymentList = CommonUtils.sortArr(
            'docDate',
            this.paymentList,
            'Date',
            -1
          );
          this.paymentList =
            !!this.paymentList && this.paymentList.length >= NumberTen
              ? this.paymentList.slice(0, NumberTen)
              : this.paymentList.slice();
          this.creditList = CommonUtils.sortArr(
            'docDate',
            this.creditList,
            'Date',
            -1
          );
          this.creditList =
            !!this.creditList && this.creditList.length >= NumberTen
              ? this.creditList.slice(0, NumberTen)
              : this.creditList.slice();
          this.paymentList.forEach((element) => {
            element.paymentAmount = this.currencyPipe.transform(
              element?.amount,
              'USD',
              symbolNarrow,
              '1.2-2'
            );
          });
          this.isLoadingDone = true;
          this.tabNavigation(tabs[0]);
          this.cdr.detectChanges();
        }
      }
    );
  }

  getInvoicesCreditData() {
    if (!_.isEmpty(this.accountNumber)) {
      this.makeAPayment.getInvoices({
        accountId: this.accountNumber,
        fields: 'DEFAULT',
      });
    }
  }

  sortColumn(event, fieldName, dataList, type): any {
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }

  invoicePdf(invoiceNo): void {
    this.makeAPayment.downloadPdf(invoiceNo);
  }

  creditPdf(creditNo): void {
    this.makeAPayment.downloadPdf(creditNo);
  }

  tabNavigation(id): void {
    this.selectedTab = id;
    if (this.selectedTab === tabs[0]) {
      this.showXlsPdf =
        !!this.paymentList && this.paymentList.length > 0 ? true : false;
      this.cdr.detectChanges();
    } else if (this.selectedTab === tabs[1]) {
      this.showXlsPdf =
        !!this.creditList && this.creditList.length > 0 ? true : false;
      this.cdr.detectChanges();
    } else {
      this.showXlsPdf = false;
      this.cdr.detectChanges();
    }
  }

  async generatePDF(): Promise<void> {
    this.isPDF = true;
    this.cdr.detectChanges();
    // SSR guard
    if (typeof window === 'undefined') {
      this.isPDF = false;
      return;
    }
    const isInvoices = this.selectedTab === 'INVOICES';
    const config = {
      INVOICES: {
        elemId: 'invoice-table',
        filename: 'invoicedetail.pdf',
      },
      CREDITS: {
        elemId: 'credits-table',
        filename: 'creditdetails.pdf',
      },
    } as const;
    const currentConfig =
      this.selectedTab === 'INVOICES' ? config.INVOICES : config.CREDITS;
    const element = document.getElementById(currentConfig.elemId);
    if (!element) {
      this.isPDF = false;
      this.cdr.detectChanges();
      return;
    }
    const domClone = element.cloneNode(true) as HTMLElement;
    // Remove unwanted column(s)
    try {
      if (isInvoices) {
        domClone.childNodes?.[0]?.childNodes?.[1]?.parentNode?.removeChild(
          domClone.childNodes[0].childNodes[1]
        );
      } else {
        domClone.childNodes?.[1]?.parentNode?.removeChild(
          domClone.childNodes[1]
        );
      }
    } catch (error) {
      console.error('Error while removing DOM nodes', error);
    }

    // Build PDF section
    const section = document.createElement('section');
    section.setAttribute('id', 'pdf-invoices');
    section.classList.add('pdf-invoices-view');
    const header = document.getElementById('pdf-header');
    const subHeader = document.getElementById('pdf-subheader');
    const line = document.getElementById('line-sanofi');
    if (header) {
      section.appendChild(header);
    }
    if (subHeader) {
      section.appendChild(subHeader);
    }
    if (line) {
      section.appendChild(line);
    }
    section.appendChild(domClone);

    const dummy = document.getElementById('pdf-dummy');
    if (!dummy) {
      this.isPDF = false;
      this.cdr.detectChanges();
      return;
    }

    dummy.appendChild(section);

    const updatedElem = dummy;

    // Wait for images to load
    const images = Array.from(updatedElem.querySelectorAll('img'));
    await Promise.all(
      images.map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) {
              resolve(true);
            } else {
              img.onload = () => resolve(true);
              img.onerror = () => resolve(false);
            }
          })
      )
    );

    const options = {
      margin: 10,
      filename: currentConfig.filename,
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'portrait' },
    } as any;

    // Dynamic import (SSR-safe)
    const html2pdfModule = await import('html2pdf.js');

    await html2pdfModule.default().from(updatedElem).set(options).save();

    // Cleanup
    section.remove();

    this.isPDF = false;
    this.cdr.detectChanges();
  }

  generateExcel() {
    const filename =
      this.selectedTab === 'INVOICES' ? 'invoicedetail' : 'creditdetails';
    let data = [];
    data = this.computeDataForExcel();
    this.acService.downloadXls(data, filename, true);
  }

  computeDataForExcel() {
    const data = [];
    if (this.selectedTab === 'INVOICES') {
      const invoiceLabelHeaders = [];
      for (const item of this.excelInvoiceHeaderIds) {
        invoiceLabelHeaders.push(document.getElementById(item).textContent);
      }
      this.paymentList.forEach((element) => {
        let invDocNo = '';
        invDocNo = this.findAccurateDocNo(element);
        data.push({
          [invoiceLabelHeaders[0]]: element.docDate,
          [invoiceLabelHeaders[1]]: invDocNo,
          [invoiceLabelHeaders[NumberTwo]]: element.docDate,
          [invoiceLabelHeaders[NumberThree]]: element.amount,
          //[invoiceLabelHeaders[NumberFour]]: element.amount,
        });
      });
    } else {
      const creditLabelHeaders = [];
      for (const item of this.excelCreditsHeaderIds) {
        creditLabelHeaders.push(document.getElementById(item).textContent);
      }
      this.creditList.forEach((element) => {
        let docNo = '';
        docNo = this.findAccurateDocNo(element);
        data.push({
          [creditLabelHeaders[0]]: element.docDate,
          [creditLabelHeaders[1]]: docNo,
          [creditLabelHeaders[NumberTwo]]: element.amount,
        });
      });
    }
    return data;
  }

  findAccurateDocNo(elem) {
    if (elem?.docType === 'DZ') {
      return elem.dochdrtxt;
    } else if (elem?.docType === 'YR') {
      return elem.refhdr;
    } else {
      return elem.refDocNo;
    }
  }

  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  dateComparison(dueDate): boolean {
    return CommonUtils.dateComparison(dueDate, this.myDate);
  }
  ngOnDestroy() {
    this.creditInvoiceSub?.unsubscribe();
    this.userAccSub?.unsubscribe();
  }
}
